module.exports = __webpack_public_path__ + "media/images/affiliate-chart-2ff9c71c86e84ef340bc2753c55e2ee2.png";